import * as React from "react";
import Input from "./Input";
import { CustomerType } from "../api/ApiClient";

interface Props {
  value: string;
  name: string;
  onValidPid?(pid: string): void;
  disabled?: boolean;
  innerRef?: React.Ref<any>;
  skipFirstInput: boolean;
  customerType?: CustomerType;
  required: boolean;
}

export class PidInput extends React.Component<Props> {
  render() {
    return (
      <Input
        name={this.props.name}
        value={this.props.value}
        placeholder={
          this.props.customerType == CustomerType.Business
            ? "Organisationsnummer"
            : "Personnummer"
        }
        validations={{
          matchRegexp:
            this.props.customerType == CustomerType.Business
              ? /^\d{10}$/
              : /^(19|20)\d{6}\d{4}$/,
        }}
        validationError={
          this.props.customerType == CustomerType.Business
            ? "Skriv in ditt organisationsnummer: XXXXXXNNNN"
            : "Skriv in ditt personnummer: ÅÅÅÅMMDDNNNN"
        }
        required={this.props.required ?? true}
        onValidInput={this.props.onValidPid}
        adjustValue={this.adjustPid}
        type={"tel"}
        disabled={this.props.disabled}
        skipFirstInput={this.props.skipFirstInput}
        ref={this.props.innerRef}
      />
    );
  }

  adjustPid = (pid: string): string => {
    pid = pid.replace(/[^\d]/g, "");
    if (this.props.customerType != CustomerType.Business) {
      if (
        pid &&
        pid.length == 10 &&
        !pid.startsWith("19") &&
        !pid.startsWith("20")
      ) {
        return (parseInt(pid.substring(0, 2)) <= 5 ? "20" : "19") + pid;
      }
      return pid.length > 12 ? pid.substring(0, 12) : pid;
    } else {
      return pid.length > 10 ? pid.substring(0, 10) : pid;
    }
  };
}

export default React.forwardRef((props: Props, ref) => (
  <PidInput innerRef={ref} {...props} />
));
